/* Product gallery: the arrows leave the photos (they covered the words) and sit in a bar under the gallery with
   "1 / 7" and progress dots, so people still see they can swipe (Yannick, Oct 23 2026). The original buttons are
   moved, not copied, so their click handlers keep working. */
(function () {
  function setup(g) {
    var track = g.querySelector('.vsp-track');
    var prev = g.querySelector('.vsp-arrow.vsp-prev');
    var next = g.querySelector('.vsp-arrow.vsp-next');
    if (!track || !prev || !next || g.querySelector('.vgn')) return;
    var slides = track.querySelectorAll(':scope > .vsp-slide');
    if (slides.length < 2) return;
    var bar = document.createElement('div');
    bar.className = 'vgn';
    var mid = document.createElement('div');
    mid.className = 'vgn-mid';
    var count = document.createElement('span');
    count.className = 'vgn-count';
    var dots = document.createElement('span');
    dots.className = 'vgn-dots';
    for (var i = 0; i < slides.length; i++) dots.appendChild(document.createElement('i'));
    mid.appendChild(count);
    mid.appendChild(dots);
    prev.classList.add('vgn-btn');
    next.classList.add('vgn-btn');
    bar.appendChild(prev);
    bar.appendChild(mid);
    bar.appendChild(next);
    track.insertAdjacentElement('afterend', bar);
    function update() {
      var w = track.clientWidth || 1;
      var n = Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / w)));
      count.textContent = (n + 1) + ' / ' + slides.length + '  ·  Swipe for more';
      var ds = dots.children;
      for (var j = 0; j < ds.length; j++) ds[j].classList.toggle('on', j === n);
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function run() { document.querySelectorAll('.vsp-gallery').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
